/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.insights.rpc.UserInsightsChirpService
 */
import * as References from './UserInsightsChirpService';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.insights.rpc.UserInsightsChirpService#getUserInsights
 */
export const GET_USER_INSIGHTS_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_insights_rpc_UserInsightsChirpService_getUserInsights';
export const GET_USER_INSIGHTS_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetUserInsightsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_USER_INSIGHTS_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetUserInsightsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getUserInsightsRpc,
      { timeout: ctx.timeout, request: {} }
    );
  },
});
